import { createAction, props } from '@ngrx/store';
import { CategoryResponse } from '@app/common/category-response';

export const loadPublicCategories = createAction(
  '[Public Categories] Load Public Categories'
);

export const loadPublicCategoriesSuccess = createAction(
  '[Public Categories] Load Public Categories Success',
  props<{ response: CategoryResponse }>()
);

export const loadPublicCategoriesFailure = createAction(
  '[Public Categories] Load Public Categories Failure',
  props<{ error: any }>()
);
